/**
 * App Version Configuration
 * Semantic Versioning: MAJOR.MINOR.PATCH
 * - MAJOR: Breaking changes
 * - MINOR: New features (backwards compatible)
 * - PATCH: Bug fixes
 */

export const APP_VERSION = '2.8.1';
export const APP_NAME = 'S.H.R.T. Mitgliederportal';
export const APP_BUILD_DATE = '2026-10-06';

export const DEVELOPER = {
  name: 'Thomas Barth',
  email: 'barththomas@mac.com'
};

// Changelog - newest first
export const CHANGELOG = [
  {
    version: '2.8.1',
    date: '2026-10-06',
    title: 'Event-Ticket immer in der Bestätigung',
    changes: [
      { type: 'fix', text: 'Anmeldebestätigungen enthalten jetzt immer das Ticket-PDF – auch bei Gratis-Events (bisher nur bei Barzahlung)' },
      { type: 'fix', text: 'Ticket auch für Gäste, nach Nachrücken von der Warteliste und bei Bestätigung durch Admins' },
      { type: 'fix', text: 'Kein Ticket, solange eine Online-Zahlung offen ist; Warteliste erhält das Ticket beim Nachrücken' },
      { type: 'fix', text: 'Gratis-Tickets zeigen den QR-Code statt «Barzahlung CHF 0.00»' },
      { type: 'fix', text: 'Keine doppelten Bestätigungsmails bei Doppelklick oder gleichzeitigen Stornierungen' },
      { type: 'fix', text: 'Sicherheit: Namen aus dem öffentlichen Gastformular werden in E-Mails gefiltert' },
    ]
  },
  {
    version: '2.8.0',
    date: '2026-07-15',
    title: 'PDF-Dateien im Rückblick',
    changes: [
      { type: 'feature', text: 'Rückblick: Bis zu 3 PDF-Dateien pro Event hochladbar (Cloudflare R2)' },
      { type: 'feature', text: 'PDF-Download-Links im Mitgliederbereich und auf der öffentlichen Events-Seite' },
    ]
  },
  {
    version: '2.7.6',
    date: '2026-05-26',
    title: 'Soft Delete & Organizer-Benachrichtigung',
    changes: [
      { type: 'feature', text: 'Abmeldungen bleiben im Admin sichtbar (Soft Delete statt Löschung)' },
      { type: 'feature', text: 'Organisator erhält E-Mail bei Abmeldung eines Teilnehmers' },
      { type: 'feature', text: 'Erneute Anmeldung nach Stornierung möglich' },
    ]
  },
  {
    version: '2.7.5',
    date: '2026-04-30',
    title: 'Bildoptimierung & Galerie-Bugfixes',
    changes: [
      { type: 'feature', text: 'Bilder: Neue Resize-Logik – max. 2400px an der längeren Kante (statt nur Breite)' },
      { type: 'feature', text: 'Galerie: Drag & Drop auf Mobile verbessert – grössere Griffe, nur am Handle ziehbar' },
      { type: 'feature', text: 'Fahrzeug-Bilder: Automatische Optimierung + Thumbnails bei Upload' },
      { type: 'fix', text: 'Rückblick: Weisse Seite beim Speichern/Löschen von Bildern behoben (Schema-Fix)' },
      { type: 'fix', text: 'Alle bestehenden Bilder (Events, Marktplatz, Fahrzeuge) auf neues Format migriert' },
    ]
  },
  {
    version: '2.7.4',
    date: '2026-03-16',
    title: 'Newsletter-Tracking, Bildupload & Fusszeile',
    changes: [
      { type: 'fix', text: 'Newsletter: Tracking-Links funktionieren jetzt auch via member.shrt.ch (Redirect zum Backend)' },
      { type: 'fix', text: 'Events: Bildupload in der Rückblick-Galerie repariert (URL-Korrektur upload/r2)' },
      { type: 'feature', text: 'Newsletter: Fusszeile mit Kuno Schär │ Teamleiter und Kontaktdaten' },
      { type: 'feature', text: 'Marktplatz: Automatische Bildoptimierung beim Upload (max. 1800px + 600px Thumbnails)' },
      { type: 'fix', text: 'camt.053: AddtlNtryInf mit vollständigem Buchungstext für ClubDesk-Kompatibilität' },
      { type: 'fix', text: 'Event-Anmeldung: HTML-Tags im Zahlungshinweis korrekt gerendert' },
    ]
  },
  {
    version: '2.7.3',
    date: '2026-03-16',
    title: 'Newsletter-Fusszeile & Bugfixes',
    changes: [
      { type: 'feature', text: 'Newsletter: Zentrierte Adresse (kunoschaer. – motorsport&events) im Footer' },
      { type: 'fix', text: 'Event-Anmeldung: HTML-Tags im Zahlungshinweis korrekt gerendert' },
    ]
  },
  {
    version: '2.7.2',
    date: '2026-03-13',
    title: 'Bild-Optimierung, camt.053-Fix & Bugfix',
    changes: [
      { type: 'feature', text: 'Marktplatz: Bilder werden beim Upload automatisch auf max. 1800px Breite skaliert' },
      { type: 'feature', text: 'Marktplatz: Thumbnails (max. 600px) werden automatisch erstellt' },
      { type: 'feature', text: 'Alle 42 bestehenden Marktplatz-Bilder wurden migriert und optimiert' },
      { type: 'fix', text: 'camt.053: <AddtlNtryInf> mit vollständigem Buchungstext für ClubDesk-Kompatibilität' },
      { type: 'fix', text: 'Event-Anmeldung: HTML-Tags (<strong>) im Zahlungshinweis werden jetzt korrekt gerendert' },
    ]
  },
  {
    version: '2.7.1',
    date: '2026-03-11',
    title: 'camt.053 ClubDesk-Kompatibilität',
    changes: [
      { type: 'fix', text: 'camt.053: <AddtlNtryInf> mit vollständigem Buchungstext (Name + Beschreibung) auf Ntry-Ebene hinzugefügt — Schweizer Standard für ClubDesk-Import' },
      { type: 'fix', text: 'camt.053: Alle Eintragstypen (Zahlungen, Gebühren, Climate, Auszahlungen, Rückerstattungen) mit AddtlNtryInf versehen' },
    ]
  },
  {
    version: '2.7.0',
    date: '2026-03-11',
    title: 'Rechnungs-Export, camt.053-Fix & Rechnungsnummern in Finance-Tabelle',
    changes: [
      { type: 'feature', text: 'Neuer Export-Button "Rechnungen": Alle Rechnungen aus der Datenbank (bezahlt + offen) als ZIP mit CSV + camt.053' },
      { type: 'feature', text: 'Rechnungen-Export getrennt nach Mitgliedsbeiträgen und Eintrittsgebühren (separate Dateien)' },
      { type: 'feature', text: 'Rechnungsnummern und Event-Namen werden in der Stripe Finance Tabelle angezeigt (via Checkout Session Metadata)' },
      { type: 'fix', text: 'camt.053: Führendes Komma im ClubDesk-Buchungstext behoben — Mitgliedsname jetzt in <RltdPties><Dbtr><Nm> statt im Ustrd-Text' },
      { type: 'fix', text: 'camt.053: Alle Eintragstypen (Gebühren, Climate, Auszahlungen, Rückerstattungen) haben jetzt korrekte Partei-Informationen' },
      { type: 'fix', text: 'iframe Auto-Resize: postMessage-Typ korrigiert (shrt-resize) für korrekte Höhenanpassung auf www.shrt.ch' },
    ]
  },
  {
    version: '2.6.0',
    date: '2026-03-10',
    title: 'Stripe Finance Dashboard, ClubDesk-Export & iframe-Optimierung',
    changes: [
      { type: 'feature', text: 'Stripe Finance Dashboard: Live-Übersicht über Guthaben, Gebühren, Auszahlungen und Climate-Beiträge' },
      { type: 'feature', text: 'ClubDesk-Export: Gesamt-Export (CSV + camt.053) als ZIP-Download' },
      { type: 'feature', text: 'ClubDesk-Export: Pro-Gegenkonto-Export mit separaten Dateien pro Buchungskonto (3000, 4200, 6750, etc.)' },
      { type: 'feature', text: 'Exportprotokoll: Automatische Protokollierung aller Exporte mit Datum, Typ und Benutzer' },
      { type: 'feature', text: 'Gast-Event-Zahlungen werden automatisch erkannt und dem richtigen Event zugeordnet' },
      { type: 'feature', text: 'Rechnungsnummern und Event-Namen im Buchungstext und bei Gebühren sichtbar' },
      { type: 'feature', text: 'Manuelle Rechnungserstellung für Jahres- und Eintrittsgebühren' },
      { type: 'feature', text: 'E-Mail-Benachrichtigung bei Rechnungsstorno' },
      { type: 'feature', text: 'Marktplatz: "Per E-Mail teilen" und externer Link auf Inseraten' },
      { type: 'feature', text: 'Dedizierte iframe-URL /embed/events für www.shrt.ch (kein SSR, kein Header)' },
      { type: 'improvement', text: 'Admin-Sidebar reorganisiert in klappbare Gruppen (Finanzen, Mitglieder, Kommunikation, etc.)' },
      { type: 'improvement', text: 'Marktplatz: Standort, Besichtigungsmöglichkeit und Verkäufer-Profil-Link' },
      { type: 'fix', text: 'Marktplatz: Neue Felder (location, viewing_possible, external_link) werden korrekt gespeichert' },
      { type: 'fix', text: 'camt.053: Kein führendes Komma mehr im Buchungstext (RltdPties entfernt)' },
      { type: 'fix', text: 'Build-Fehler in StripeFinancePage.jsx behoben' },
    ]
  },
  {
    version: '2.5.8',
    date: '2026-03-09',
    title: 'Nachrichten-Badge, SSR-Vereinheitlichung & AGB',
    changes: [
      { type: 'feature', text: 'Ungelesene Nachrichten: Rote Bubble mit Zahl im Menü bei "Nachrichten"' },
      { type: 'feature', text: 'Ungelesene Nachrichten: Hinweis auf der Startseite mit Direktlink' },
      { type: 'feature', text: 'Öffentliche Support-Seite (/support) mit SSR und React-Version' },
      { type: 'improvement', text: 'Einheitlicher Header auf allen öffentlichen Seiten (Datenschutz, AGB, Impressum, Support)' },
      { type: 'improvement', text: 'Support-Link in der Startseiten-Navigation (oben und unten)' },
      { type: 'improvement', text: 'AGB komplett überarbeitet: Zahlungsempfänger, Stornierungsregelungen, Bildrechte' },
      { type: 'fix', text: 'Gelöschte Event-Anmeldungen können erneut hinzugefügt werden' },
      { type: 'fix', text: 'E-Mail mit Ticket wird bei manueller Anmeldung durch Admin/Organisator verschickt' },
    ]
  },
  {
    version: '2.5.7',
    date: '2026-03-09',
    title: 'Manuelle Teilnehmer-Anmeldung',
    changes: [
      { type: 'feature', text: 'Admins und Organisatoren können Teilnehmer manuell zu Events hinzufügen (Mitglieder oder Gäste)' },
      { type: 'feature', text: 'Mitglieder-Suche mit Autocomplete beim Hinzufügen' },
      { type: 'feature', text: 'Gast-Anmeldung mit Name, E-Mail, Telefon und Begleitung' },
      { type: 'feature', text: 'Zahlungsart für manuelle Anmeldungen ist immer Barzahlung' },
    ]
  },
  {
    version: '2.5.6',
    date: '2026-03-09',
    title: 'Marktplatz, Support-Seite & Öffentliche Inserate',
    changes: [
      { type: 'feature', text: 'Öffentliche Inserat-Seite zum Teilen ohne Login (mit Bildergalerie, Details & optionalen Kontaktdaten)' },
      { type: 'feature', text: 'Marktplatz: Standort des Fahrzeugs und "Besichtigung möglich" Checkbox' },
      { type: 'feature', text: 'Marktplatz: Kontaktdaten auf öffentlicher Seite optional anzeigen' },
      { type: 'feature', text: 'Öffentliche Kundensupport-Seite (/support) mit SSR und in der Navigation' },
    ]
  },
  {
    version: '2.5.5',
    date: '2026-03-09',
    title: 'PWA Update-Fix',
    changes: [
      { type: 'fix', text: 'PWA Update-Navigation führt jetzt zu /home statt / (behebt "Not Found" auf Mobile Safari)' },
    ]
  },
  {
    version: '2.5.4',
    date: '2026-03-09',
    title: 'Startseite, Bilder-Upload & PWA-Fix',
    changes: [
      { type: 'feature', text: 'Mehrfachauswahl beim Bild-Upload (mehrere Dateien gleichzeitig wählen oder per Drag & Drop)' },
      { type: 'feature', text: 'Maximal 20 Bilder pro Inserat mit Zähler-Anzeige' },
      { type: 'improvement', text: 'PWA startet jetzt immer auf /home (Mitglieder-Startseite)' },
      { type: 'fix', text: 'PWA Update-Benachrichtigung für Chrome Desktop verbessert (controllerchange + updatefound Listener)' },
    ]
  },
  {
    version: '2.5.3',
    date: '2026-03-09',
    title: 'Marktplatz-Erweiterung, AGB & Umfrage-Navigation',
    changes: [
      { type: 'feature', text: 'Marktplatz: Bilder per Drag & Drop sortieren (Titelbild = erstes Bild)' },
      { type: 'feature', text: 'Marktplatz: "Verkauft"-Badge auf Inserat-Karten' },
      { type: 'feature', text: 'Marktplatz: Vorschau der neusten Inserate auf der Startseite' },
      { type: 'feature', text: 'Marktplatz: "Als verkauft markieren" & "Wieder aktivieren" für Eigentümer' },
      { type: 'feature', text: 'Marktplatz: Admin-Sperr-Funktion für Inserate' },
      { type: 'feature', text: 'Marktplatz: Teilen via WhatsApp, Link kopieren, öffentliche Seite' },
      { type: 'feature', text: 'AGB komplett überarbeitet (Stand: März 2026) – 13 Abschnitte inkl. Merchandise, Haftung, Datenschutz' },
      { type: 'fix', text: 'Zurück-Button auf öffentlicher Umfrageseite hinzugefügt' },
      { type: 'fix', text: 'Admin-Erkennung auf Inserat-Detailseite korrigiert (AuthContext statt JWT)' },
    ]
  },
  {
    version: '2.5.2',
    date: '2026-03-08',
    title: 'SSR Produktion, Compliance & PWA',
    changes: [
      { type: 'feature', text: 'Production-Server (server.js) für SSR auf Render — Bots sehen jetzt alle öffentlichen Seiten' },
      { type: 'feature', text: 'Thomas Barth als technischer Ansprechpartner auf allen SSR- und React-Seiten' },
      { type: 'fix', text: 'PWA startet jetzt direkt im Mitgliederbereich (/dashboard) statt Landing Page' },
      { type: 'fix', text: 'Impressum: Vertretungsberechtigte Personen ergänzt (Kuno Schär + Thomas Barth)' },
    ]
  },
  {
    version: '2.5.1',
    date: '2026-03-08',
    title: 'PWA Update-Fix & Gast-Anmeldung',
    changes: [
      { type: 'fix', text: 'PWA: Service Worker wird jetzt korrekt registriert — Update-Benachrichtigung funktioniert' },
      { type: 'fix', text: '"Als Gast anmelden" öffnet jetzt das React-Anmeldeformular statt der SSR-Seite' },
      { type: 'improvement', text: 'SW Update-Check: Alle 5 Min + bei App-Fokus + sofort beim Start' },
    ]
  },
  {
    version: '2.5.0',
    date: '2026-03-08',
    title: 'SSR Landing Page, Öffentliche Events & Compliance',
    changes: [
      { type: 'feature', text: 'Neue öffentliche Startseite (SSR) mit Logo, Willkommenstext und interaktiven Event-Karten' },
      { type: 'feature', text: 'Events auf Startseite mit Accordion (aufklappbar) — identische Funktion wie der shrt.ch-Iframe' },
      { type: 'feature', text: 'Aufgeklappte Events zeigen Beschreibung, Preis, Teilnehmer, Aktions-Buttons (Anmeldung, Gast, Link)' },
      { type: 'feature', text: 'Rückblicke-Sektion mit Review-Badge und Bilder-Vorschau für vergangene Events' },
      { type: 'feature', text: 'Server-Side Rendering (SSR) für alle öffentlichen Seiten (SEO & Stripe-Compliance)' },
      { type: 'feature', text: 'Dynamische robots.txt und sitemap.xml Endpoints' },
      { type: 'feature', text: 'Datenschutzerklärung (Stripe/TWINT/SPUKL-konform) als SSR-Seite' },
      { type: 'feature', text: 'Einheitlicher PublicFooter auf allen öffentlichen Seiten' },
      { type: 'fix', text: 'Logo auf Startseite: Inline-SVG statt kaputte externe URL' },
      { type: 'fix', text: 'Events auf Startseite und /public/events: show_public-Filter entfernt (Feld existierte nicht)' },
      { type: 'fix', text: 'AGB-Seite (SSR): Korrektur der DB-Abfrage (content statt terms)' },
      { type: 'fix', text: 'Mobile Responsiveness auf Event-Detailseite (kein Overflow mehr)' },
      { type: 'fix', text: 'Build-Fehler in SurveysPage behoben (JSX-Fragment und catch-Blöcke)' },
      { type: 'fix', text: 'Umfrage "Multiple Choice mit Menge": Mengenangaben werden jetzt gespeichert' },
    ]
  },
  {
    version: '2.20.0',
    date: '2026-03-06',
    title: 'Eintrittsgebühr, Mitgliederbewegungen & E-Mail-Konsolidierung',
    changes: [
      { type: 'feature', text: 'Eintrittsgebühr (CHF 250) konfigurierbar in Rechnungseinstellungen' },
      { type: 'feature', text: 'Eintrittsgebühr als separate Position auf Erstjahres-Rechnungen' },
      { type: 'feature', text: 'Admin-Seite "Mitgliederbewegungen" mit Eintritte/Austritte-Statistik' },
      { type: 'feature', text: 'Stornieren-Button für offene Rechnungen mit Grund-Eingabe' },
      { type: 'feature', text: 'Resend-Webhook für automatische Bounce-Erkennung' },
      { type: 'feature', text: '"Sync mit Resend" Button in der Kampagnen-Auswertung' },
      { type: 'improvement', text: 'Eine E-Mail, ein Feld: member.email als einzige Quelle der Wahrheit' },
      { type: 'improvement', text: 'E-Mail-Änderungen aktualisieren automatisch alle zugehörigen Rechnungen' },
      { type: 'improvement', text: 'Monday.com-Sync findet Mitglieder auch via monday_id (nicht nur E-Mail)' },
      { type: 'improvement', text: 'Zahlungspflichtig als Checkbox statt Freitextfeld' },
      { type: 'improvement', text: 'Rechnungsübersicht zeigt Mitglieder total und Zahlungspflichtige' },
      { type: 'improvement', text: 'Bezahlte/stornierte Rechnungen können nicht mehr versendet werden' },
      { type: 'fix', text: 'Rechnungs-PDF und E-Mail zeigen korrekten Total-Betrag inkl. Eintrittsgebühr' },
      { type: 'fix', text: 'Individuelle Jahresbeiträge zurückgesetzt – Standardbeitrag gilt für alle' },
    ]
  },
  {
    version: '2.19.0',
    date: '2026-03-06',
    title: 'Marktplatz, Umfragen & Rechnungsschutz',
    changes: [
      { type: 'feature', text: 'Marktplatz: Fahrzeuge zum Verkauf anbieten oder Suchinserate aufgeben' },
      { type: 'feature', text: 'Marktplatz: In-App Nachrichtensystem zwischen Käufer und Verkäufer' },
      { type: 'feature', text: 'Umfrage-System: Umfragen erstellen, per Newsletter versenden, anonym beantworten' },
      { type: 'feature', text: 'Umfrage-Ergebnisse: Echtzeit-Auswertung mit Balkendiagrammen' },
      { type: 'feature', text: 'Dashboard: Aktive Umfragen werden als Banner auf der Startseite angezeigt' },
      { type: 'feature', text: 'Fahrzeuggalerie: Neue "Fan-Stack" Ansicht, gruppiert nach Besitzer' },
      { type: 'feature', text: 'Automatische Rechnungsstornierung bei Mitgliederaustritt' },
      { type: 'improvement', text: 'Bezahlte/stornierte Rechnungen können nicht mehr erneut versendet werden' },
      { type: 'improvement', text: 'Lightbox: Swipe-Navigation für Touch-Geräte' },
      { type: 'improvement', text: 'Admin-Toggle für Umfrage-Sichtbarkeit auf dem Dashboard' },
    ]
  },
  {
    version: '2.18.0',
    date: '2026-03-05',
    title: 'Like-Feature, Organisator-Benachrichtigung & UI-Verbesserungen',
    changes: [
      { type: 'feature', text: 'Like-Funktion (Daumen hoch) für Fahrzeuge mit Social Proof' },
      { type: 'feature', text: 'Fancybox-Lightbox für Fahrzeugbilder mit Zoom und Swipe' },
      { type: 'feature', text: 'E-Mail-Benachrichtigung an den Organisator bei jeder Event-Anmeldung (Mitglied & Gast)' },
      { type: 'improvement', text: 'Sauberer Card-Footer: Besitzer links, Like-Button rechts mit Trennlinie' },
      { type: 'improvement', text: 'Umbenennung "Veranstalter" → "Organisator (Kontaktperson)" in der gesamten App' },
      { type: 'improvement', text: 'Sticky Navigation bleibt beim Scrollen sichtbar (Desktop)' },
      { type: 'fix', text: '"Not Found" Toast-Bug auf Mitglied-Detailseite behoben (Race Condition)' },
    ]
  },
  {
    version: '2.17.0',
    date: '2026-03-04',
    title: 'Newsletter-Editor, Sticky Navigation & Feinschliff',
    changes: [
      { type: 'feature', text: 'TipTap WYSIWYG-Editor im Event-Newsletter-Modal (statt HTML-Textarea)' },
      { type: 'improvement', text: 'Desktop-Navigation ist jetzt sticky (bleibt beim Scrollen sichtbar)' },
      { type: 'improvement', text: 'Uhrzeit wird im Share-Text angezeigt (z.B. "13:30 Uhr")' },
      { type: 'improvement', text: '"Mitglieder-Anmeldung" Button oberhalb des Gast-Formulars auf der öffentlichen Event-Seite' },
      { type: 'improvement', text: 'Event teilen zeigt immer auf die öffentliche Event-Seite' },
    ]
  },
  {
    version: '2.16.0',
    date: '2026-03-04',
    title: 'Versandgruppen, Tracking-Fix & UI-Verbesserungen',
    changes: [
      { type: 'feature', text: 'Ausgetretene Mitglieder werden automatisch aus allen Versandgruppen entfernt' },
      { type: 'feature', text: 'Newsletter Click-Tracking: Links in E-Mails werden für Klick-Statistiken umgeleitet' },
      { type: 'feature', text: 'Newsletter Open-Tracking: Tracking-Pixel für Öffnungsrate' },
      { type: 'improvement', text: 'Tracking-Links verwenden die schöne Domain member.shrt.ch mit automatischer Weiterleitung' },
      { type: 'improvement', text: 'Event teilen zeigt immer auf die öffentliche Event-Seite' },
      { type: 'improvement', text: '"Mitglieder-Anmeldung" Button oberhalb des Gast-Formulars auf der öffentlichen Event-Seite' },
      { type: 'fix', text: 'Newsletter Tracking-Links mit Query-Parametern werden korrekt URL-encoded' },
    ]
  },
  {
    version: '2.15.0',
    date: '2026-03-04',
    title: 'Newsletter-Tracking, Änderungsbenachrichtigungen & Monday.com Sync',
    changes: [
      { type: 'feature', text: 'Newsletter: Open-Tracking (Pixel) und Click-Tracking (Link-Redirect) für alle Kampagnen' },
      { type: 'feature', text: 'E-Mail-Benachrichtigung an Mitglieder bei Bestätigung/Ablehnung von Profiländerungen' },
      { type: 'feature', text: 'Änderungen desselben Mitglieds (2h-Fenster) werden gruppiert angezeigt und per E-Mail zusammengefasst' },
      { type: 'feature', text: 'Monday.com: Neue Spalte "Austrittsdatum" für ausgetretene Mitglieder' },
      { type: 'improvement', text: 'Monday.com: Name-basiertes Matching als Fallback, alle Mitglieder verknüpft' },
      { type: 'improvement', text: 'Newsletter-Inhalt: "Einladung" Überschrift, S.H.R.T.-Prefix im Titel, Datum ohne Jahr' },
      { type: 'improvement', text: 'Event teilen: Komma statt "in" vor dem Ort, Member-Link im Mitgliederbereich' },
      { type: 'fix', text: 'Monday.com: String-vs-Dict Feldextraktion in Diff, Export und Sync behoben' },
    ]
  },
  {
    version: '2.14.0',
    date: '2026-03-04',
    title: 'Event teilen (WhatsApp, E-Mail, Link)',
    changes: [
      { type: 'feature', text: 'Events teilen: WhatsApp, Link kopieren und E-Mail auf der öffentlichen Event-Seite' },
      { type: 'feature', text: '"Teilen" Button auf der Mitglieder-Event-Seite mit Dropdown (WhatsApp, Link, E-Mail)' },
      { type: 'feature', text: 'Geteilte Links führen immer zur öffentlichen Event-Seite für einfache Gast-Registrierung' },
      { type: 'improvement', text: 'Native "Teilen"-Funktion auf Mobilgeräten (Web Share API)' },
    ]
  },
  {
    version: '2.13.0',
    date: '2026-03-04',
    title: 'Änderungsprotokoll, Schweizer Telefonnummern & Bugfixes',
    changes: [
      { type: 'feature', text: 'Änderungsprotokoll: Freigegebene und abgelehnte Änderungen bleiben dauerhaft einsehbar' },
      { type: 'feature', text: 'Telefonnummern werden überall im Schweizer Format angezeigt (+41 XX XXX XX XX)' },
      { type: 'improvement', text: 'Monday.com: Bei gelöschten Items wird die Änderung trotzdem lokal freigegeben' },
      { type: 'improvement', text: 'Begleitpersonen: Dropdown (0/1/2) statt freies Zahlenfeld, max. 2' },
      { type: 'improvement', text: 'Newsletter-Buttons "Als Mitglied" und "Als Gast" untereinander statt nebeneinander' },
      { type: 'fix', text: 'Änderungsseite: Alte Werte als lesbarer Text statt raw JSON' },
      { type: 'fix', text: 'Öffentliche Events: Doppelte Anzeige von Datum/Ort im aufgeklappten Event entfernt' },
    ]
  },
  {
    version: '2.12.0',
    date: '2026-03-04',
    title: 'Organisator, Meine Events & Öffentliche Event-Seite',
    changes: [
      { type: 'feature', text: 'Organisator (Kontaktperson) pro Event: Kontaktperson aus Mitgliederliste wählen (Pflichtfeld mit Suchfunktion)' },
      { type: 'feature', text: '"Meine Events" Seite: Organisatoren sehen Teilnehmerliste und können alle Teilnehmer direkt anschreiben' },
      { type: 'feature', text: 'Öffentliche Event-Detailseite: Direkter Link für Newsletter an Gäste (/public/event/{id})' },
      { type: 'feature', text: 'SHRT-Promo-Footer auf öffentlicher Event-Seite mit "Mitglied werden" CTA' },
      { type: 'feature', text: 'Newsletter enthält Organisator-Kontaktdaten und zwei Buttons (Mitglied/Gast)' },
      { type: 'feature', text: 'Kopierbarer öffentlicher Event-Link auf der Bearbeitungsseite' },
      { type: 'improvement', text: 'Gast-Anmeldung im iframe öffnet neue Event-Seite in eigenem Fenster' },
      { type: 'fix', text: 'Monday.com: Bessere Fehlermeldung bei gelöschten Items (InvalidItemIdException)' },
      { type: 'fix', text: 'Änderungsseite: Alte Werte werden als Text statt raw JSON angezeigt' },
    ]
  },
  {
    version: '2.11.0',
    date: '2026-03-04',
    title: 'Gast-Anmeldung, Downloads & PWA-Update-Fix',
    changes: [
      { type: 'feature', text: 'Gast-Anmeldung: Nicht-Mitglieder können sich direkt für Events registrieren und bezahlen' },
      { type: 'feature', text: 'Inline-Anmeldeformular für Events (iframe-kompatibel und mobilfreundlich)' },
      { type: 'feature', text: 'Downloads-Bereich: Allgemeine Dateien mit benutzerdefinierten Titeln hochladen und verwalten' },
      { type: 'feature', text: 'Live-Fortschrittsanzeige beim Newsletter-Versand (Status, Prozent, Fortschrittsbalken)' },
      { type: 'improvement', text: 'PWA Auto-Update repariert: Versionsnummern über alle Komponenten synchronisiert' },
      { type: 'improvement', text: 'Gast-Anmeldung per Toggle pro Event aktivierbar' },
      { type: 'improvement', text: 'Gäste werden in der Teilnehmerliste mit blauem Badge gekennzeichnet' },
    ]
  },
  {
    version: '2.10.0',
    date: '2026-03-03',
    title: 'Newsletter-Fix, Dateianhänge & Dokumenttypen',
    changes: [
      { type: 'feature', text: 'Event-Dateianhänge: PDFs und Bilder an Events anhängen (R2-Upload, max 10MB)' },
      { type: 'feature', text: 'Dateianhänge erscheinen als Download-Links auf der Event-Seite und automatisch im Newsletter' },
      { type: 'feature', text: 'Neue Dokumenttypen: Jahresberichte und Finanzberichte hochladen und verwalten' },
      { type: 'feature', text: 'Mitglieder sehen Jahres- und Finanzberichte auf der Dokumente-Seite' },
      { type: 'feature', text: 'Fehlgeschlagene Newsletter-Empfänger: "Erneut senden" Button im Kampagnen-Report' },
      { type: 'feature', text: 'Event-Newsletter übernimmt jetzt den kompletten Beschreibungstext inkl. Programm und Teilnahmegebühr' },
      { type: 'fix', text: 'Newsletter-Zustellung: Fehler vom E-Mail-Provider werden jetzt korrekt erfasst und angezeigt' },
      { type: 'fix', text: 'Rate-Limiting: Verzögerung zwischen E-Mails auf 1.2s erhöht (Resend-Limit: 2/sec)' },
      { type: 'improvement', text: '3 Retry-Versuche mit exponentiellem Backoff bei Newsletter-Versand' },
      { type: 'improvement', text: 'Fehlermeldungen pro Empfänger im Newsletter-Report sichtbar' },
    ]
  },
  {
    version: '2.9.0',
    date: '2026-03-01',
    title: 'Rechnungsversand & E-Mail-Verbesserungen',
    changes: [
      { type: 'feature', text: 'Kampagnen archivieren und wiederherstellen' },
      { type: 'feature', text: 'Rechnungsversand nutzt jetzt den konfigurierten E-Mail-Provider (SMTP oder Resend), inkl. Anhänge' },
      { type: 'feature', text: 'CSV-Export funktioniert jetzt auch bei Token-basierter Authentifizierung (Browser-Downloads)' },
      { type: 'improvement', text: 'Alle E-Mails (Rechnungen, Bestätigungen, Mahnungen) verwenden einheitliches Newsletter-Template' },
      { type: 'improvement', text: 'Alle E-Mail-Texte konsequent per Du' },
      { type: 'improvement', text: 'Rechnungs-E-Mail: Hinweis auf Rechnung und Einzahlungsschein als PDF in der Anlage' },
      { type: 'improvement', text: 'Aktions-Buttons bei Rechnungen grösser, farblich unterschieden, mit Tooltips' },
      { type: 'improvement', text: 'Wochentag wird bei Events und in E-Mails immer angezeigt' },
      { type: 'improvement', text: '"Alle Mitglieder" ist jetzt Standard-Auswahl im Event-Newsletter-Dialog' },
      { type: 'fix', text: 'Überfällig-Status nur noch bei bereits versendeten Rechnungen' },
      { type: 'fix', text: 'Rückerstattete Rechnungen können jetzt gelöscht werden' },
      { type: 'fix', text: 'Stripe Payment Link: Zahlungen werden über Metadata-Lookup korrekt zugeordnet' },
      { type: 'fix', text: 'Öffentliche Events-Seite: Button-Padding korrigiert' },
    ]
  },
  {
    version: '2.8.0',
    date: '2026-03-01',
    title: 'Newsletter-System Überarbeitung & Resend-Integration',
    changes: [
      { type: 'feature', text: 'Resend als zweiter E-Mail-Provider (neben SMTP) — umschaltbar in den Admin-Einstellungen' },
      { type: 'feature', text: 'Versandgruppen (Custom Mailing Lists) mit voller CRUD-Verwaltung' },
      { type: 'feature', text: 'Intelligenter CSV-Import mit Vorschau und automatischem Spalten-Mapping' },
      { type: 'feature', text: '"Alle Mitglieder" als auswählbare Systemgruppe mit individueller Abo-Verwaltung' },
      { type: 'feature', text: 'Event-Newsletter → Kampagne: "Alle Mitglieder" erstellt automatisch eine vorausgefüllte Kampagne mit Event-Infos und CTA-Button' },
      { type: 'improvement', text: 'Kontaktverwaltung komplett redesigned: Tabelle mit Suche, Bulk-Aktionen, Duplikaterkennung' },
      { type: 'improvement', text: 'Empfänger-Auswahl bei Newsletter und Kampagnen neu gestaltet (Gruppen-basiert)' },
      { type: 'improvement', text: 'Event-Button wird beim Kampagnen-Erstellen aus Event automatisch eingefügt' },
      { type: 'fix', text: 'Render-Deployment: emergentintegrations aus requirements.txt entfernt' },
      { type: 'fix', text: 'DNS-Tippfehler billder → bilder in E-Mail-Templates korrigiert' },
    ]
  },
  {
    version: '2.7.0',
    date: '2026-03-01',
    title: 'Aktivitätslog, Bugfixes & Verbesserungen',
    changes: [
      { type: 'feature', text: 'Zentrales Aktivitätslog für alle wichtigen Aktionen (Login, Rechnungen, Zahlungen, Events, Admin)' },
      { type: 'feature', text: 'Neue Admin-Seite "Aktivitätslog" mit Suche und Filtern' },
      { type: 'fix', text: 'Rechnungsnummern sind jetzt garantiert eindeutig (auch nach Löschen)' },
      { type: 'fix', text: 'Event-Sichtbarkeit (Checkboxen) wird beim Speichern korrekt übermittelt' },
      { type: 'improvement', text: 'Events-Seite: Rückblicke und vergangene Events als separate Gruppen' },
      { type: 'improvement', text: 'Öffentliche Events-Seite: 70% grössere Schrift auf Desktop' },
      { type: 'improvement', text: 'Install-Seite erkennt Gerät automatisch (iOS/Android/Desktop)' },
    ]
  },
  {
    version: '2.6.0',
    date: '2026-02-28',
    title: 'Synchronisation & Zahlungsmethoden',
    changes: [
      { type: 'feature', text: 'Neue Synchronisations-Seite: Vergleich App vs Monday.com mit Import/Export' },
      { type: 'feature', text: 'Admin kann Zahlungsmethoden (Kreditkarte, TWINT, Barzahlung) aktivieren/deaktivieren' },
      { type: 'feature', text: 'Tech Stack Anzeige auf der About-Seite mit visuellen Karten' },
      { type: 'fix', text: 'Stripe TWINT Fehler: Automatischer Fallback wenn TWINT nicht aktiviert' },
      { type: 'improvement', text: 'Zahlungsoptionen bei Events dynamisch aus Admin-Einstellungen' },
    ]
  },
  {
    version: '2.5.5',
    date: '2026-02-21',
    title: 'Installations-Anleitung',
    changes: [
      { type: 'feature', text: 'Neue Seite: App-Installationsanleitung für iOS, Android und Desktop' },
      { type: 'feature', text: '"Zum ersten Mal hier?" Link auf der Login-Seite' },
    ]
  },
  {
    version: '2.5.4',
    date: '2026-02-21',
    title: 'Mobile Layout Fix',
    changes: [
      { type: 'fix', text: 'Mitgliederdetails: Kein horizontales Scrollen mehr auf Mobile' },
      { type: 'fix', text: 'Kompakteres Layout für kleine Bildschirme' },
    ]
  },
  {
    version: '2.5.3',
    date: '2026-02-21',
    title: 'Update-Logik korrigiert',
    changes: [
      { type: 'fix', text: 'Update-Benachrichtigung zeigt nur NEUERE Versionen an' },
      { type: 'fix', text: 'Semantische Versionsvergleich (2.5.3 > 2.5.2 > 2.5.1)' },
    ]
  },
  {
    version: '2.5.2',
    date: '2026-02-21',
    title: 'iOS PWA Update-Fix',
    changes: [
      { type: 'fix', text: 'iOS PWA: Update-Benachrichtigung funktioniert jetzt korrekt' },
      { type: 'improvement', text: 'Update-Check bei App-Fokus (wenn App in Vordergrund kommt)' },
      { type: 'improvement', text: 'Spezielle Anleitung für iOS-Nutzer beim Update' },
    ]
  },
  {
    version: '2.5.1',
    date: '2026-02-21',
    title: 'PWA Updates & Fixes',
    changes: [
      { type: 'feature', text: 'PWA Update-Benachrichtigung: Push-Meldung bei neuer Version' },
      { type: 'feature', text: 'Automatische Cache-Löschung bei Updates' },
      { type: 'fix', text: 'Versionsnummer überall konsistent (war 2.0 statt 2.5.0)' },
      { type: 'improvement', text: 'Version im Header klickbar → führt zur About-Seite' },
    ]
  },
  {
    version: '2.4.5',
    date: '2026-02-21',
    title: 'Dokumente & Verbesserungen',
    changes: [
      { type: 'feature', text: 'Dokumentenverwaltung: Statuten und GV-Protokolle hochladen und anzeigen' },
      { type: 'feature', text: 'VCF-Export: Kontakte als vCard speichern' },
      { type: 'feature', text: 'Impressum-Seite für TWINT-Anforderungen' },
      { type: 'feature', text: 'Über diese App Seite mit Changelog' },
      { type: 'improvement', text: 'Mobile Darstellung der Mitgliederdetails optimiert' },
      { type: 'improvement', text: 'Logo auf Cloudflare R2 für E-Mail-Darstellung' },
      { type: 'fix', text: 'Check-in Validierung: Falsches Event wird korrekt erkannt' },
      { type: 'fix', text: 'Event-Registrierungsmodal passt auf Mobile' },
    ]
  },
  {
    version: '2.4.0',
    date: '2026-02-10',
    title: 'PWA & Zahlungsfix',
    changes: [
      { type: 'feature', text: 'Progressive Web App (PWA): App kann auf Homescreen installiert werden' },
      { type: 'feature', text: 'Benutzerdefinierte PWA-Icons ohne Verzerrung' },
      { type: 'fix', text: 'Kritischer Bug: "Stuck on Verifying Payment" behoben' },
      { type: 'improvement', text: 'Event-Registrierungsmodal für Mobile optimiert' },
    ]
  },
  {
    version: '2.3.0',
    date: '2026-02-01',
    title: 'Ticket-System',
    changes: [
      { type: 'feature', text: 'QR-Code Tickets für Events mit PDF-Download' },
      { type: 'feature', text: 'Admin Check-in Seite mit QR-Scanner' },
      { type: 'feature', text: 'Ticket-Versand per E-Mail' },
      { type: 'feature', text: 'Event-Rückblick (Bilder nach Event)' },
    ]
  },
  {
    version: '2.2.0',
    date: '2026-01-15',
    title: 'Newsletter-System',
    changes: [
      { type: 'feature', text: 'Vollständiges Newsletter-System mit Kampagnen' },
      { type: 'feature', text: 'Drag & Drop Newsletter-Editor' },
      { type: 'feature', text: 'Öffentliche Events-Seite zum Einbetten' },
      { type: 'feature', text: 'Newsletter-Abonnenten Verwaltung' },
    ]
  },
  {
    version: '2.1.0',
    date: '2026-01-01',
    title: 'Event-Buchung & Zahlungen',
    changes: [
      { type: 'feature', text: 'Stripe-Integration für Online-Zahlungen (inkl. TWINT)' },
      { type: 'feature', text: 'Barzahlungsoption für Events' },
      { type: 'feature', text: 'Gästeverwaltung bei Event-Anmeldungen' },
      { type: 'feature', text: 'Warteliste bei ausgebuchten Events' },
    ]
  },
  {
    version: '2.0.0',
    date: '2025-12-01',
    title: 'Großes Redesign',
    changes: [
      { type: 'feature', text: 'Komplett neues UI-Design' },
      { type: 'feature', text: 'Fahrzeugverwaltung mit Bildergalerie' },
      { type: 'feature', text: 'Auto des Monats Feature' },
      { type: 'feature', text: 'Monday.com Integration' },
      { type: 'improvement', text: 'Performance-Optimierungen' },
    ]
  },
  {
    version: '1.0.0',
    date: '2025-10-01',
    title: 'Erste Version',
    changes: [
      { type: 'feature', text: 'Mitgliederverwaltung' },
      { type: 'feature', text: 'Event-Kalender' },
      { type: 'feature', text: 'Rechnungsverwaltung' },
      { type: 'feature', text: 'Admin-Dashboard' },
    ]
  }
];

// Get change type label and color
export const getChangeTypeInfo = (type) => {
  switch (type) {
    case 'feature':
      return { label: 'Neu', color: 'bg-green-500/20 text-green-500' };
    case 'improvement':
      return { label: 'Verbessert', color: 'bg-blue-500/20 text-blue-500' };
    case 'fix':
      return { label: 'Behoben', color: 'bg-orange-500/20 text-orange-500' };
    case 'security':
      return { label: 'Sicherheit', color: 'bg-red-500/20 text-red-500' };
    default:
      return { label: type, color: 'bg-muted text-muted-foreground' };
  }
};
